import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import './AcceptProposal.scss';
var getUtmParams = function getUtmParams() {
  return {
    source: 'hiredfeedback',
    medium: 'inapp',
    campaign: 'hiringmanagerhired'
  };
};
var AcceptProposal = /*#__PURE__*/function (_Component) {
  function AcceptProposal(props) {
    var _this;
    _classCallCheck(this, AcceptProposal);
    _this = _callSuper(this, AcceptProposal, [props]);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(AcceptProposal, _Component);
  return _createClass(AcceptProposal, [{
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var _this$props = this.props,
        formUrl = _this$props.formUrl,
        csrfToken = _this$props.csrfToken;
      var utmParams = getUtmParams();
      var newUrl = "".concat(window.location.pathname, "?prompt_nps=true&") + "utm_source=".concat(utmParams.source, "&") + "utm_medium=".concat(utmParams.medium, "&") + "utm_campaign=".concat(utmParams.campaign);
      return putRequest(formUrl, {}, csrfToken).then(function () {
        window.location.href = newUrl;
      })["catch"](function (err) {
        _this2.setState({
          errors: err
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        consultantName = _this$props2.consultantName,
        buttonStyles = _this$props2.buttonStyles,
        triggerType = _this$props2.triggerType;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Hire ".concat(consultantName),
        buttonStyles: buttonStyles,
        submitButtonText: "Yes, hire ".concat(consultantName),
        cancelButtonText: "Cancel",
        handleSubmit: this.handleSubmit,
        triggerType: triggerType,
        closeAfterSubmit: true,
        idKey: "accept-proposal-modal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "accept-modal style-guide"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-12"
      }, "You are about to hire", consultantName, "!"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-1 mb-8"
      }, "By clicking Hire below, you agree to award this project to", ' ', consultantName, "."), /*#__PURE__*/React.createElement("div", {
        className: "body-text-1 mb-3"
      }, "Your account manager will reach out to you and the consultant to facilitate next steps.")));
    }
  }]);
}(Component);
AcceptProposal.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  consultantName: PropTypes.string.isRequired,
  buttonStyles: PropTypes.string,
  triggerType: PropTypes.string
};
AcceptProposal.defaultProps = {
  buttonStyles: 'primary',
  triggerType: 'link'
};
export default AcceptProposal;